"use client";

import { createContext, useContext } from "react";

export interface PublicBranding {
  nom: string | null;
  logo_url: string | null;
  couleur_principale: string;
  couleur_secondaire: string;
}

/** Couleurs Gaelonn par défaut */
const BRANDING_GAELONN: PublicBranding = {
  nom: "Gaelonn",
  logo_url: "/logo-gaelonn.svg",
  couleur_principale: "#252E36",
  couleur_secondaire: "#C41115",
};

const BrandingContext = createContext<PublicBranding>(BRANDING_GAELONN);

export function BrandingProvider({
  children,
  branding,
}: {
  children: React.ReactNode;
  branding?: PublicBranding;
}) {
  return (
    <BrandingContext.Provider value={branding || BRANDING_GAELONN}>
      {children}
    </BrandingContext.Provider>
  );
}

export const usePublicBranding = () => useContext(BrandingContext);
